import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
  select: {
    borderRadius: 2,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  selectRoot: {
    height: 74,
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },

  heightSelect: {
    height: 76
  },

  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
}));



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


export default function SimpleSelect(props) {

  const classes = useStyles();
  const {
    items,
    value,
    name,
    textLabel,
    handleBlur,
    handleChange,
    touchedItems,
    errorsItems,
    attrib,
  } = props;

  const width = attrib ? attrib : '';


  return (


    <FormControl
      style={{ maxWidth: width }}
      classes={{ root: classes.heightSelect }}
      variant="outlined" error={touchedItems && errorsItems ? true : false}>


      <InputLabel
        htmlFor="select-multiple-checkbox"
        classes={{
          root: classes.inputLabelRoot,
          shrink: classes.inputLabelShrink,
        }}
      >
        {textLabel}
      </InputLabel>
      <Select
        id={name}
        name={name}
        value={value}

        onChange={handleChange}
      >
        {items && items.map((item, index) => (
          <MenuItem key={index} value={item.value} >
            {item.value}
          </MenuItem>
        ))}
      </Select>
      {touchedItems && errorsItems ? (
        <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
          {errorsItems}
        </FormHelperText>
      ) : (
          ''
        )}
    </FormControl>
  )
}